import { AuthenticationClient } from "authing-js-sdk";
import Axios from "axios";
import {
  isBrowser,
  isSem,
  promotingAds,
  digitalMarketingChannels,
  specialMarketingChannels,
} from "../utils";
import { getCookie } from "./cookie";
import { tryAglAPI } from "./tryAgl";

export const tryNow = (phone) => {
  tryAglAPI();
  if (isBrowser) {
    require("sa-sdk-javascript").track("TryNow");
  }
  let url = `https://console.authing.cn/oidc/auth?client_id=5f6265c67ff6fdae64ec516e&scope=openid%20email%20phone%20profile&redirect_uri=https://console.authing.cn/console/userpool/callback&response_type=code`;
  let params = {
    utm_source: sessionStorage?.getItem("utm_source") || "",
    utm_medium: sessionStorage?.getItem("utm_medium") || "",
    utm_campaign: sessionStorage?.getItem("utm_campaign") || "",
    utm_term: sessionStorage?.getItem("utm_term") || "",
    utma: getCookie("c__utma"),
    utmb: getCookie("c__utmb"),
    utm_domain: typeof window !== "undefined" && window.location.hostname,
    from_origin: "authing.cn",
  };
  // 电话登录
  if (typeof phone === "string") {
    params.active_tab_key = "phone";
    params.phone = phone;
  }
  // 其他线索来源
  let clue = {};
  if (isSem()) {
    clue.sem = true;
  }
  if (promotingAds()) {
    clue.pa = promotingAds();
  }
  if (digitalMarketingChannels()) {
    clue.dmc = digitalMarketingChannels();
  }
  if (specialMarketingChannels()) {
    if (specialMarketingChannels() === "51cto") {
      const newUrl = new URL(url);
      newUrl.host = "51cto-users.authing.cn";
      newUrl.pathname = "/register";
      url = newUrl.toString();
    }
    clue.smc = specialMarketingChannels();
  }

  Object.assign(params, clue);
  console.log(params, "params");
  const encodeURIParams = encodeURI(JSON.stringify(params));

  // 万维登录投放
  if (sessionStorage.getItem("utm_source") === "wanwei") {
    window.location.href = "https://wwads-authing.authing.cn";
  } else {
    window.open(url + `&login_page_context=${encodeURIParams}`);
    // window.location.href = url + `&login_page_context=${encodeURIParams}`;
  }
};

export const tryNowRegister = (phone) => {
  // tryAgl();
  tryAglAPI();
  if (isBrowser) {
    require("sa-sdk-javascript").track("TryNow");
  }

  const { consoleHost } = window._AUTHING__GLOBAL_CONFIG_;

  let url = `${consoleHost}/register?from_origin=authing.cn`;

  const clue = {
    utm_source: encodeURI(sessionStorage?.getItem("utm_source")) || "",
    utm_medium: encodeURI(sessionStorage?.getItem("utm_medium")) || "",
    utm_campaign: encodeURI(sessionStorage?.getItem("utm_campaign")) || "",
    utm_term: encodeURI(sessionStorage?.getItem("utm_term")) || "",
  };
  const utma = getCookie("c__utma");
  const utmb = getCookie("c__utmb");
  const utm_domain = typeof window !== "undefined" && window.location.hostname;
  if (phone) {
    url += `&active_tab_key=phone&phone=${phone}&utm_source=${clue.utm_source}&utm_medium=${clue.utm_medium}&utm_campaign=${clue.utm_campaign}&utm_term=${clue.utm_term}&utma=${utma}&utmb=${utmb}&utm_domain=${utm_domain}`;
  }

  window.location.href = urlSearch(url);
};

export const gotoRegister = tryNowRegister;

export const gotoLogin = (phone) => {
  const { appId, consoleHost } = window._AUTHING__GLOBAL_CONFIG_;

  const authClient = new AuthenticationClient({
    appId,
    appHost: consoleHost,
    redirectUri: `${consoleHost}/console/userpool/callback`,
  });

  let authUrl;

  authUrl = authClient.buildAuthorizeUrl();

  const clue = {
    active_tab_key: "phone",
    phone: phone,
    utm_source: sessionStorage?.getItem("utm_source") || "",
    utm_medium: sessionStorage?.getItem("utm_medium") || "",
    utm_campaign: sessionStorage?.getItem("utm_campaign") || "",
    utm_term: sessionStorage?.getItem("utm_term") || "",
    utma: getCookie("c__utma"),
    utmb: getCookie("c__utmb"),
    utm_domain: typeof window !== "undefined" && window.location.hostname,
  };
  if (phone) {
    for (const key in clue) {
      authUrl += `&${key}=${clue[key]}`;
    }
  }

  window.location.href = authUrl;
};

export const userLogout = async () => {
  const { consoleHost } = window._AUTHING__GLOBAL_CONFIG_;

  await Axios({
    method: "get",
    url: `${consoleHost}/cas/logout`,
    withCredentials: true,
  });
};

export const gotoConsole = () => {
  const { consoleHost } = window._AUTHING__GLOBAL_CONFIG_;

  window.location.href = `${consoleHost}/login`;
};

const urlSearch = (url) => {
  if (isSem()) {
    url += "&sem=true";
  }

  if (promotingAds()) {
    url += `&pa=${promotingAds()}`;
  }

  if (digitalMarketingChannels()) {
    url += `&dmc=${digitalMarketingChannels()}`;
  }

  if (specialMarketingChannels()) {
    if (specialMarketingChannels() === "51cto") {
      const newUrl = new URL(url);
      newUrl.host = "51cto-users.authing.cn";
      newUrl.pathname = "/register";
      url = newUrl.toString();
    }

    url += `&smc=${specialMarketingChannels()}`;
  }
  return url;
};

export const vueNowRegister = (type) => {
  // tryAgl();
  tryAglAPI();
  if (isBrowser) {
    require("sa-sdk-javascript").track("TryNow");
  }
  // let url = "https://vue-authing.authing.cn";
  const clue = {
    utm_source: encodeURI(sessionStorage?.getItem("utm_source")) || "",
    utm_medium: encodeURI(sessionStorage?.getItem("utm_medium")) || "",
    utm_campaign: encodeURI(sessionStorage?.getItem("utm_campaign")) || "",
    utm_term: encodeURI(sessionStorage?.getItem("utm_term")) || "",
  };
  const utma = getCookie("c__utma");
  const utmb = getCookie("c__utmb");
  const utm_domain = typeof window !== "undefined" && window.location.hostname;
  let url = `https://${type}-authing.authing.cn/?utm_source=${clue.utm_source}&utm_medium=${clue.utm_medium}&utm_campaign=${clue.utm_campaign}&utm_term=${clue.utm_term}&utma=${utma}&utmb=${utmb}&utm_domain=${utm_domain}`;
  return url;
};
